import React from 'react';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import SendIcon from '@mui/icons-material/Send';
import { TFunction } from 'i18next';
import { BatchAction } from 'components/orders/shared/batch-action-bar.component';

// DD-3463: the two order-state batch actions, shared by the order list, the
// workflow list and the delivery schedule.
export const BATCH_PRODUCTION_FINISHED_ACTION = 'BATCH_PRODUCTION_FINISHED';
export const BATCH_SEND_TO_CLINIC_ACTION = 'BATCH_SEND_TO_CLINIC';

export const getBatchOrderActions = (translate: TFunction): BatchAction[] => [
    {
        icon: <TaskAltIcon />,
        name: translate('orders:BATCH_PRODUCTION_FINISHED'),
        type: BATCH_PRODUCTION_FINISHED_ACTION,
    },
    {
        icon: <SendIcon />,
        name: translate('orders:BATCH_SEND_TO_CLINIC'),
        type: BATCH_SEND_TO_CLINIC_ACTION,
    },
];

export const isBatchOrderActionType = (type: string): boolean =>
    type === BATCH_PRODUCTION_FINISHED_ACTION || type === BATCH_SEND_TO_CLINIC_ACTION;

// Both actions are lab work on the lab's own orders: dentists never see them.
// DD-3391: the elevated external tier sends the orders shared with them to the
// clinic, through its own dialog and mutation. DD-3682: they finish production on
// a batch too, as they already could on a single order; the backend skips the
// orders not shared with them. The lower external tiers get neither.
export const isBatchOrderActionDisabled = (
    type: string,
    {
        isDentist,
        isExternalTechnician,
        isElevatedExternalUser,
    }: {
        isDentist: boolean;
        isExternalTechnician: boolean;
        isElevatedExternalUser: boolean;
    },
): boolean => {
    if (isDentist) {
        return true;
    }
    if (!isExternalTechnician) {
        return false;
    }
    return !(isElevatedExternalUser && isBatchOrderActionType(type));
};
